import axiosConfig from './axiosConfig';

// List inspection reports
export const getInspectionReports = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('inspectionreport', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Create inspection report
export const createInspectionReport = async (reportData) => {
    try {
        const response = await axiosConfig.post('inspectionreport', reportData);
        return response;
    } catch (error) {
        throw error || 'Failed to create inspection report';
    }
};

// Show inspection report details
export const getInspectionReportById = async (id) => {
    try {
        const response = await axiosConfig.get(`inspectionreport/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Generate report PDF
export const getInspectionReportPdf = async (id, reportID) => {
    try {
        const response = await axiosConfig.get(`inspectionreport/pdf/${id}`, { responseType: 'blob' });
        // Create a URL for the blob and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `inspection_report_${reportID}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        throw error;
    }
};

// Monthly summary
export const getInspectionReportSummary = async (month) => {
    try {
        const response = await axiosConfig.get(`inspectionreport/summary/${month}`);
        return response;
    } catch (error) {
        throw error;
    }
};